export const Config = {
  PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL || 'http://localhost:3000',
  GOOGLE_CLIENT_ID: '355877186155-dqeskbgpim66gveou9rfoq84opkg5fti.apps.googleusercontent.com'
};
